const safetyPageData = [
    {
        'subText': [
            {
                'id': 'subText1',
                'text': 'Mums ir svarīga jūsu drošība uguņošanas laikā.',
            
            },
            {
                'id': 'subText2',
                'text': 'Aicinām jūs noskatīties video, kurā attēlota droša pirotehnisko izstrādājumu lietošana.'
            }
        ],
        'safetyVideo': 'https://www.youtube-nocookie.com/embed/8E-G5UHuxCQ',
        'rulesIntro': 'Citi ieteikumi',
        'otherRules': [
            {
                'id': 'otherRule0',
                'text': 'Praktizējiet drošu uguņošanu un nododiet šo tradīciju tālāk draugiem un paziņām'
            },
            {
                'id': 'otherRule1',
                'text': 'Vienmēr iegādājieties pirotehniskos izstrādājumos licencētos veikalos'
            },
            {
                'id': 'otherRule2',
                'text': 'Pirms izstrādājuma lietošanas, izlasiet lietošanas instrukciju, kas ir atrodama uz pašu izstrādājumu'
            }, 
            {
                'id': 'otherRule3',
                'text': 'Vēlams, lai izstrādājuma palaišanas vietas tuvumā būtu pieeja ūdenim (spainis vai pudele ar ūdeni) vai uguns dzēšamajam aparātam'
            },
            {
                'id': 'otherRule4',
                'text': 'Pirotehniku jāglabā aukstā un sausā vietā - galvenais neatstāt salūtu uz plīts virsmu'
            },
            {
                'id': 'otherRule5',
                'text': 'Nekad nevērsiet pirotehniskos izstrādājumus pret cilvēkiem'
            },
            {
                'id': 'otherRule6',
                'text': 'Nekad nemetiet pirotehniskos izstrādājumus metāla vai plastmasas izstrādājumiem domātā konteinerā'
            },
            {
                'id': 'otherRule7',
                'text': 'Ja notrūkusi degaukla, nemēģiniet to sameistarot paši'
            },
            {
                'id': 'otherRule8',
                'text': 'Līdz galam neizšāvušam pirotehnikas izstrādājumam netuvojaties līdz ir pagājušas 15 minūtes'
            },
            {
                'id': 'otherRule9',
                'text': 'Pirotehniskie izstrādājumi jālieto ārā'
            },
            {
                'id': 'otherRule10',
                'text': 'Pirotehniku nedrīkst lietot un iegādāties nepilngadīgie, kas nav sasnieguši 18 gadu vecumu, bez vecāku vai cita pilngadīgā uzraudzības'
            },
            {
                'id': 'otherRule11',
                'text': 'Pievērsiet uzmanību, lai skatītājs ir drošā attālumā (lielākajai daļai izstrādājumu drošs attālums būs 25 metri)'
            },
            {
                'id': 'otherRule12',
                'text': 'Noskaidrojiet, vai izstrādājumam netraucē elektrības vadi vai koki'
            },
            {
                'id': 'otherRule13',
                'text': 'Pārliecinieties par to, ka pirotehniskie izstrādājumi ir drošā attālumā no mājām'
            },
            {
                'id': 'otherRule14',
                'text': 'Pārliecinieties, vai apkārt nav sausa zāle, kura var viegli uzliesmot no dzirksteles'
            },
            {
                'id': 'otherRule15',
                'text': 'Pārbaudiet vēja virzienu, vējam ir jāpūš dūmi prom no skatītājiem'
            },
            {
                'id': 'otherRule16',
                'text': 'Nešaujiet pirotehniskos izstrādājumus liela vēja laikā, vēja ātrumam būtu jābūt apmēram zem 9 m/s'
            },
            {
                'id': 'otherRule17',
                'text': 'Salūtu novietojiet uz līdzenas vietas'
            },
            {
                'id': 'otherRule18',
                'text': 'Nešaujiet pirotehniskos izstrādājumus, esot alkohola reibumā'
            },
            {
                'id': 'otherRule19',
                'text': 'Ja kādam nav patīkama pirotehnikas šaušana, tad aizveriet logus un aizvelciet aizkarus, tas mazinās gaismas un skaņas efektus'
            },
            {
                'id': 'otherRule20',
                'text': 'Izlietotos izstrādājumus nemetiet ugunskurā'
            },
            {
                'id': 'otherRule21',
                'text': 'Visdrošāk ir apvienot naudas līdzekļus ar paziņam vai/un draugiem, un iegādāties lielāku salūtu pie profesionāļiem'
            }
        ]
    }
]

export default safetyPageData;